import React, { useEffect, useMemo } from "react";
import {
  Grid,
  Card,
  Tooltip,
  Button,
  MenuItem,
  Select,
  FormControl,
  IconButton,
  Badge,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  CircularProgress,
  InputLabel,
  Chip,
  Divider,
  Container,
  useTheme,
  Avatar,
  Stack,
  InputAdornment,
  FormHelperText,
  CardContent,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Switch,
  FormControlLabel,
  Tabs,
  Tab,
  Alert
} from "@mui/material";

// Icons
import RefreshIcon from "@mui/icons-material/Refresh";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SecurityIcon from "@mui/icons-material/Security";
import PeopleIcon from "@mui/icons-material/People";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BusinessIcon from "@mui/icons-material/Business";
import WarningIcon from "@mui/icons-material/Warning";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import GroupIcon from "@mui/icons-material/Group";
import EventIcon from "@mui/icons-material/Event";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ScheduleIcon from "@mui/icons-material/Schedule";

import SuperAdminDashboardVM from "../viewmodal/SuperAdminDashboardVM";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// FIXED: Move OverviewCards outside to prevent recreation
const OverviewCards = React.memo(({ dashboardData }) => (
  <Grid container spacing={3} sx={{ mb: 4 }}>
    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={2} sx={{ p: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, color: '#333' }}>
              {dashboardData.totalTerminals || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total Terminals
            </Typography>
          </Box>
          <BusinessIcon sx={{ fontSize: 40, color: '#1976d2' }} />
        </Box>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={2} sx={{ p: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, color: '#333' }}>
              {dashboardData.activeTerminals || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Active Terminals
            </Typography>
          </Box>
          <CheckCircleIcon sx={{ fontSize: 40, color: '#4caf50' }} />
        </Box>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={2} sx={{ p: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, color: '#333' }}>
              {dashboardData.totalUsers || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total Users
            </Typography>
          </Box>
          <GroupIcon sx={{ fontSize: 40, color: '#1976d2' }} />
        </Box>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={2} sx={{ p: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, color: '#333' }}>
              {dashboardData.totalVisits || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Total Visits
            </Typography>
          </Box>
          <EventIcon sx={{ fontSize: 40, color: '#1976d2' }} />
        </Box>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={2} sx={{ p: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, color: '#333' }}>
              {dashboardData.pendingVisits || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Pending Visits
            </Typography>
          </Box>
          <ScheduleIcon sx={{ fontSize: 40, color: '#ff9800' }} />
        </Box>
      </Card>
    </Grid>

    <Grid item xs={12} sm={6} md={4}>
      <Card elevation={2} sx={{ p: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1, color: '#333' }}>
              {dashboardData.activeVisitors || 0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Active Visitors
            </Typography>
          </Box>
          <TrendingUpIcon sx={{ fontSize: 40, color: '#4caf50' }} />
        </Box>
      </Card>
    </Grid>
  </Grid>
));

// FIXED: Move TerminalModal outside to prevent recreation
const TerminalModal = React.memo(({
  showTerminalModal,
  setShowTerminalModal,
  editingTerminal,
  terminalForm,
  handleTerminalFormChange,
  validationErrors,
  countries,
  loading,
  handleTerminalSubmit
}) => (
  <Dialog
    open={showTerminalModal}
    onClose={() => setShowTerminalModal(false)}
    TransitionComponent={Transition}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle>
      {editingTerminal ? 'Edit Terminal' : 'Add New Terminal'}
    </DialogTitle>
    <DialogContent>
      <Stack spacing={3} sx={{ mt: 2 }}>
        <TextField
          label="Terminal Name"
          name="name"
          value={terminalForm.name}
          onChange={handleTerminalFormChange}
          error={!!validationErrors.name}
          helperText={validationErrors.name}
          fullWidth
          required
        />
        
        {/* CHANGED: Use text field for country in edit mode, dropdown for create */}
        {editingTerminal ? (
          <TextField
            label="Country"
            name="country"
            value={terminalForm.country}
            onChange={handleTerminalFormChange}
            error={!!validationErrors.country}
            helperText={validationErrors.country}
            fullWidth
            required
          />
        ) : (
          <FormControl fullWidth error={!!validationErrors.country} required>
            <InputLabel>Country</InputLabel>
            <Select
              name="country"
              value={terminalForm.country}
              onChange={handleTerminalFormChange}
              label="Country"
            >
              {countries.map((country) => (
                <MenuItem key={country.id} value={country.country_name}>
                  {country.country_name}
                </MenuItem>
              ))}
            </Select>
            {validationErrors.country && (
              <FormHelperText>{validationErrors.country}</FormHelperText>
            )}
          </FormControl>
        )}
        
        <TextField
          label="Time Zone"
          name="time_zone"
          value={terminalForm.time_zone}
          onChange={handleTerminalFormChange}
          error={!!validationErrors.time_zone}
          helperText={validationErrors.time_zone}
          fullWidth
          required
          placeholder="e.g., Asia/Kolkata"
        />
        
        <FormControl fullWidth>
          <InputLabel>Status</InputLabel>
          <Select
            name="status"
            value={terminalForm.status}
            onChange={handleTerminalFormChange}
            label="Status"
          >
            <MenuItem value={1}>Active</MenuItem>
            <MenuItem value={0}>Inactive</MenuItem>
          </Select>
        </FormControl>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setShowTerminalModal(false)}>
        Cancel
      </Button>
      <Button 
        onClick={handleTerminalSubmit}
        variant="contained"
        disabled={loading}
      >
        {loading ? <CircularProgress size={20} /> : (editingTerminal ? 'Update' : 'Create')}
      </Button>
    </DialogActions>
  </Dialog>
));

// FIXED: Move UserModal outside to prevent recreation
const UserModal = React.memo(({
  showUserModal,
  setShowUserModal,
  editingUser,
  userForm,
  handleUserFormChange,
  validationErrors,
  userRoles,
  terminals,
  loading,
  handleUserSubmit
}) => (
  <Dialog
    open={showUserModal}
    onClose={() => setShowUserModal(false)}
    TransitionComponent={Transition}
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle>
      {editingUser ? 'Edit User' : 'Add New User'}
    </DialogTitle>
    <DialogContent>
      <Stack spacing={3} sx={{ mt: 2 }}>
        <TextField
          label="Full Name"
          name="full_name"
          value={userForm.full_name}
          onChange={handleUserFormChange}
          error={!!validationErrors.full_name}
          helperText={validationErrors.full_name}
          fullWidth
          required
        />
        
        <TextField
          label="Email"
          name="email"
          type="email"
          value={userForm.email}
          onChange={handleUserFormChange}
          error={!!validationErrors.email}
          helperText={validationErrors.email}
          fullWidth
          required
        />
        
        <TextField
          label="Mobile Number"
          name="mobile_number"
          value={userForm.mobile_number}
          onChange={handleUserFormChange}
          error={!!validationErrors.mobile_number}
          helperText={validationErrors.mobile_number}
          fullWidth
          required
          placeholder="e.g., +919876543210"
        />
        
        {/* CHANGED: Only show role dropdown when creating new user */}
        {!editingUser && (
          <FormControl fullWidth error={!!validationErrors.role_id} required>
            <InputLabel>Role</InputLabel>
            <Select
              name="role_id"
              value={userForm.role_id}
              onChange={handleUserFormChange}
              label="Role"
            >
              {userRoles.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.role_name}
                </MenuItem>
              ))}
            </Select>
            {validationErrors.role_id && (
              <FormHelperText>{validationErrors.role_id}</FormHelperText>
            )}
          </FormControl>
        )}
        
        <FormControl fullWidth error={!!validationErrors.terminal_id} required>
          <InputLabel>Terminal</InputLabel>
          <Select
            name="terminal_id"
            value={userForm.terminal_id}
            onChange={handleUserFormChange}
            label="Terminal"
          >
            {terminals.map((terminal) => (
              <MenuItem key={terminal.id} value={terminal.id}>
                {terminal.name} ({terminal.country})
              </MenuItem>
            ))}
          </Select>
          {validationErrors.terminal_id && (
            <FormHelperText>{validationErrors.terminal_id}</FormHelperText>
          )}
        </FormControl>
        
        <FormControlLabel
          control={
            <Switch
              name="active"
              checked={userForm.active}
              onChange={handleUserFormChange}
            />
          }
          label="Active User"
        />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setShowUserModal(false)}>
        Cancel
      </Button>
      <Button 
        onClick={handleUserSubmit}
        variant="contained"
        disabled={loading}
      >
        {loading ? <CircularProgress size={20} /> : (editingUser ? 'Update' : 'Create')}
      </Button>
    </DialogActions>
  </Dialog>
));

// FIXED: Move ConfirmationDialog outside to prevent recreation
const ConfirmationDialog = React.memo(({ confirmDialog, setConfirmDialog }) => (
  <Dialog
    open={confirmDialog.open}
    TransitionComponent={Transition}
    keepMounted
    onClose={() => setConfirmDialog({ ...confirmDialog, open: false })}
    PaperProps={{
      sx: {
        borderRadius: 2,
        minWidth: 400,
      }
    }}
  >
    <DialogTitle sx={{ 
      display: 'flex', 
      alignItems: 'center',
      color: '#d32f2f',
      fontWeight: 600
    }}>
      <WarningIcon sx={{ mr: 1.5 }} />
      {confirmDialog.title}
    </DialogTitle>
    <DialogContent sx={{ pt: 2 }}>
      <DialogContentText sx={{ fontSize: '1rem', color: 'text.primary' }}>
        {confirmDialog.message}
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ p: 2 }}>
      <Button 
        onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}
        variant="outlined"
        sx={{ 
          textTransform: 'none',
          px: 3
        }}
      >
        Cancel
      </Button>
      <Button 
        onClick={confirmDialog.onConfirm} 
        variant="contained"
        color="error"
        sx={{ 
          textTransform: 'none',
          px: 3,
          ml: 2
        }}
      >
        Delete
      </Button>
    </DialogActions>
  </Dialog>
));

// FIXED: Move DashboardHeader outside to prevent recreation
const DashboardHeader = React.memo(({ dashboardData, successMessage, errorMessage, closeAlerts }) => (
  <Box sx={{ mb: 4 }}>
    <Box sx={{ mb: 4, textAlign: 'center' }}>
      <Typography 
        variant="h4" 
        sx={{ 
          fontWeight: "bold",
          color: '#333',
          mb: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <SupervisorAccountIcon sx={{ mr: 2, color: '#1976d2' }} />
        Super Admin Dashboard
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Manage terminals, monitor users, and oversee visitor activities across all locations
      </Typography>
    </Box>

    {/* Alert Messages */}
    {successMessage && (
      <Alert severity="success" onClose={closeAlerts} sx={{ mb: 2 }}>
        {successMessage}
      </Alert>
    )}
    
    {errorMessage && (
      <Alert severity="error" onClose={closeAlerts} sx={{ mb: 2 }}>
        {errorMessage}
      </Alert>
    )}

    <OverviewCards dashboardData={dashboardData} />
  </Box>
));

const SuperAdminDashboardView = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const {
    // Dashboard state
    loading,
    dashboardData,
    
    // Terminals state
    terminals,
    selectedTerminal,
    terminalUsers,
    terminalVisits,
    
    // Countries and roles
    countries,
    userRoles,
    
    // Active tab
    activeTab,
    
    // Modal states
    showTerminalModal,
    showUserModal,
    editingTerminal,
    editingUser,
    
    // Form states
    terminalForm,
    userForm,
    
    // Search and filters
    searchText,
    filterStatus,
    filterRole,
    
    // Validation
    validationErrors,
    
    // Messages
    successMessage,
    errorMessage,
    
    // Confirmation dialog
    confirmDialog,
    setConfirmDialog,
    
    // Filtered data
    filteredTerminalUsers,
    filteredTerminalVisits,
    
    // Handlers
    handleTerminalChange,
    handleTabChange,
    handleSearchChange,
    handleTerminalFormChange,
    handleUserFormChange,
    handleTerminalSubmit,
    handleUserSubmit,
    handleDeleteTerminal,
    handleDeleteUser,
    handleEditTerminal,
    handleEditUser,
    
    // Modal handlers
    setShowTerminalModal,
    setShowUserModal,
    resetTerminalForm,
    resetUserForm,
    
    // Filter handlers
    setFilterStatus,
    setFilterRole,
    
    // Utilities
    closeAlerts,
    fetchDashboardData
  } = SuperAdminDashboardVM();

  // FIXED: Memoize all tab content to prevent recreation
  const TerminalsTab = useMemo(() => (
    <Box>
      <Card elevation={2} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Terminal Management
            </Typography>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => {
                resetTerminalForm();
                setShowTerminalModal(true);
              }}
            >
              Add Terminal
            </Button>
          </Box>
          
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Terminal Name</TableCell>
                  <TableCell>Country</TableCell>
                  <TableCell>Time Zone</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {terminals.map((terminal) => (
                  <TableRow key={terminal.id}>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <BusinessIcon sx={{ mr: 1, color: 'primary.main' }} />
                        {terminal.name}
                      </Box>
                    </TableCell>
                    <TableCell>{terminal.country}</TableCell>
                    <TableCell>{terminal.time_zone}</TableCell>
                    <TableCell>
                      <Chip 
                        label={terminal.status ? 'Active' : 'Inactive'}
                        color={terminal.status ? 'success' : 'default'}
                        size="small"
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Edit">
                        <IconButton
                          onClick={() => handleEditTerminal(terminal)}
                          color="primary"
                          size="small"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          onClick={() => handleDeleteTerminal(terminal)}
                          color="error"
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  ), [terminals, resetTerminalForm, setShowTerminalModal, handleEditTerminal, handleDeleteTerminal]);

  const UsersTab = useMemo(() => (
    <Box>
      {/* Terminal Selector */}
      <Card elevation={2} sx={{ mb: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <FormControl fullWidth>
                <InputLabel>Select Terminal</InputLabel>
                <Select
                  value={selectedTerminal}
                  onChange={(e) => handleTerminalChange(e.target.value)}
                  label="Select Terminal"
                >
                  <MenuItem value="">All Terminals</MenuItem>
                  {terminals.map((terminal) => (
                    <MenuItem key={terminal.id} value={terminal.id}>
                      {terminal.name} ({terminal.country})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                placeholder="Search users..."
                value={searchText}
                onChange={handleSearchChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  label="Status"
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  resetUserForm();
                  setShowUserModal(true);
                }}
                fullWidth
                disabled={!selectedTerminal}
              >
                Add User
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Users Table */}
      <Card elevation={2} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
        {loading && <LinearProgress />}
        <TableContainer sx={{ maxHeight: '60vh' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>User Details</TableCell>
                <TableCell>Contact Info</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTerminal ? (
                filteredTerminalUsers.length > 0 ? (
                  filteredTerminalUsers.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar sx={{ mr: 2, bgcolor: 'primary.main' }}>
                            {user.full_name.charAt(0).toUpperCase()}
                          </Avatar>
                          <Box>
                            <Typography variant="body2" fontWeight={500}>
                              {user.full_name}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              ID: {user.id}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Stack spacing={0.5}>
                          <Typography variant="body2">{user.email}</Typography>
                          <Typography variant="body2">{user.mobile_number}</Typography>
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={user.role_name}
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={user.active ? 'Active' : 'Inactive'}
                          color={user.active ? 'success' : 'default'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Edit">
                          <IconButton
                            onClick={() => handleEditUser(user)}
                            color="primary"
                            size="small"
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton
                            onClick={() => handleDeleteUser(user)}
                            color="error"
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                      <InfoIcon fontSize="large" color="disabled" />
                      <Typography variant="h6" color="text.secondary">
                        No users found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    <LocationCityIcon fontSize="large" color="disabled" />
                    <Typography variant="h6" color="text.secondary">
                      Select a terminal to view users
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  ), [
    selectedTerminal, 
    terminals, 
    searchText, 
    handleSearchChange, 
    filterStatus, 
    setFilterStatus, 
    resetUserForm, 
    setShowUserModal, 
    loading, 
    filteredTerminalUsers, 
    handleEditUser, 
    handleDeleteUser,
    handleTerminalChange
  ]);

  const VisitsTab = useMemo(() => (
    <Box>
      {/* Terminal Selector for Visits */}
      <Card elevation={2} sx={{ mb: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Select Terminal</InputLabel>
                <Select
                  value={selectedTerminal}
                  onChange={(e) => handleTerminalChange(e.target.value)}
                  label="Select Terminal"
                >
                  <MenuItem value="">All Terminals</MenuItem>
                  {terminals.map((terminal) => (
                    <MenuItem key={terminal.id} value={terminal.id}>
                      {terminal.name} ({terminal.country})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                placeholder="Search visits..."
                value={searchText}
                onChange={handleSearchChange}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Visits Table */}
      <Card elevation={2} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
        {loading && <LinearProgress />}
        <TableContainer sx={{ maxHeight: '60vh' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Visitor</TableCell>
                <TableCell>Approver</TableCell>
                <TableCell>Purpose</TableCell>
                <TableCell>Visit Period</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Check In/Out</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedTerminal ? (
                filteredTerminalVisits.length > 0 ? (
                  filteredTerminalVisits.map((visit) => (
                    <TableRow key={visit.id}>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar sx={{ mr: 2, bgcolor: 'secondary.main' }}>
                            {visit.visitor_name.charAt(0).toUpperCase()}
                          </Avatar>
                          <Typography variant="body2">
                            {visit.visitor_name}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {visit.approver_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" sx={{ maxWidth: 200 }}>
                          {visit.purpose}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Stack spacing={0.5}>
                          <Typography variant="caption">
                            From: {new Date(visit.visit_from).toLocaleDateString()}
                          </Typography>
                          <Typography variant="caption">
                            To: {new Date(visit.visit_till).toLocaleDateString()}
                          </Typography>
                        </Stack>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={visit.status}
                          size="small"
                          color={
                            visit.status === 'Approved' ? 'success' :
                            visit.status === 'Pending' ? 'warning' : 'error'
                          }
                        />
                      </TableCell>
                      <TableCell>
                        <Stack spacing={0.5}>
                          <Typography variant="caption">
                            In: {visit.check_in ? new Date(visit.check_in).toLocaleString() : 'Not checked in'}
                          </Typography>
                          <Typography variant="caption">
                            Out: {visit.check_out ? new Date(visit.check_out).toLocaleString() : 'Not checked out'}
                          </Typography>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                      <EventIcon fontSize="large" color="disabled" />
                      <Typography variant="h6" color="text.secondary">
                        No visits found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                    <LocationCityIcon fontSize="large" color="disabled" />
                    <Typography variant="h6" color="text.secondary">
                      Select a terminal to view visits
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  ), [
    selectedTerminal, 
    terminals, 
    searchText, 
    handleSearchChange, 
    loading, 
    filteredTerminalVisits,
    handleTerminalChange
  ]);

  return (
    <Box 
      sx={{ 
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        py: { xs: 2, sm: 4 },
        px: { xs: 2, sm: 3 },
        mt: { xs: 10, sm: 12 },
      }}
    >
      <Container maxWidth="xl">
        <DashboardHeader 
          dashboardData={dashboardData}
          successMessage={successMessage}
          errorMessage={errorMessage}
          closeAlerts={closeAlerts}
        />
        
        {/* Navigation Tabs */}
        <Card elevation={2} sx={{ mb: 3, borderRadius: 2, border: '1px solid #e0e0e0' }}>
          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => handleTabChange(newValue)}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtons="auto"
          >
            <Tab 
              label="Terminals" 
              value="terminals" 
              icon={<BusinessIcon />}
              iconPosition="start"
            />
            <Tab 
              label="Users" 
              value="users" 
              icon={<GroupIcon />}
              iconPosition="start"
            />
            <Tab 
              label="Visits" 
              value="visits" 
              icon={<EventIcon />}
              iconPosition="start"
            />
          </Tabs>
        </Card>

        {/* Tab Content */}
        {activeTab === "terminals" && TerminalsTab}
        {activeTab === "users" && UsersTab}
        {activeTab === "visits" && VisitsTab}

        {/* Modals */}
        <TerminalModal 
          showTerminalModal={showTerminalModal}
          setShowTerminalModal={setShowTerminalModal}
          editingTerminal={editingTerminal}
          terminalForm={terminalForm}
          handleTerminalFormChange={handleTerminalFormChange}
          validationErrors={validationErrors}
          countries={countries}
          loading={loading}
          handleTerminalSubmit={handleTerminalSubmit}
        />
        
        <UserModal 
          showUserModal={showUserModal}
          setShowUserModal={setShowUserModal}
          editingUser={editingUser}
          userForm={userForm}
          handleUserFormChange={handleUserFormChange}
          validationErrors={validationErrors}
          userRoles={userRoles}
          terminals={terminals}
          loading={loading}
          handleUserSubmit={handleUserSubmit}
        />
        
        <ConfirmationDialog 
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Container>
    </Box>
  );
};

export default SuperAdminDashboardView;